export default "__VITE_ASSET__BRUjXlmy__"